var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex_end"},[_c('router-link',{staticClass:"split-link",attrs:{"to":{path:'/service/split'},"target":"_blank"}},[_c('u',[_vm._v("スプリットとは")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }